import { render } from "./SportInfoTooltip.vue?vue&type=template&id=8cb2d6d0"
import script from "./SportInfoTooltip.vue?vue&type=script&lang=js"
export * from "./SportInfoTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__